import defaultCopy from '../../constants/defaultCopy';

export const SET_LANGUAGE = 'SET_LANGUAGE';

export const setLanguage = (languageProperties) => (dispatch, getState) => {
  const {
    page: { languageCode },
  } = getState();

  const defaultLangCopy = defaultCopy[languageCode] || {};
  const defaultLangKeys = Object.keys(defaultLangCopy);
  const mergedLanguage = defaultLangKeys.reduce(
    (acc, keyWithDefault) => {
      acc[keyWithDefault] =
        typeof acc[keyWithDefault] === 'string'
          ? acc[keyWithDefault]
          : defaultLangCopy[keyWithDefault];
      return acc;
    },
    { ...languageProperties },
  );

  return dispatch({
    type: SET_LANGUAGE,
    data: { languageProperties: mergedLanguage },
  });
};
